import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  API_SERVICE_KEYS,
  apiFacadeKeyName,
  apiFacadeKeyValue,
  apiOnboardingKeyName,
  apiOnboardingKeyValue,
  endpoints,
  getDataFetcher,
} from "./ApiConfig";
import { AbsoluteUrlRegEx } from "../utils/regex.utils";
import { AxiosError } from "axios";
import { transformAxiosToFetchBaseQueryErrorWithLocationRedirect } from "../utils";

export const selectApi = createApi({
  reducerPath: "selectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: headers => {
      if (apiFacadeKeyName && apiFacadeKeyValue) {
        headers.set(apiFacadeKeyName, apiFacadeKeyValue);
      }
      if (apiOnboardingKeyName && apiOnboardingKeyValue) {
        headers.set(apiOnboardingKeyName, apiOnboardingKeyValue);
      }
      return headers;
    },
  }),
  tagTypes: ["selectList"],
  endpoints: builder => ({
    getSelectList: builder.query<
      Record<string, unknown>[],
      {
        url: string;
        headers: string[] | Record<string, string> | undefined;
      }
    >({
      async queryFn({ url, headers: rawHeaders }) {
        const isAbsolute = AbsoluteUrlRegEx.test(url);
        const path = isAbsolute ? url : `${endpoints.base}/${url}`;
        let headers: Record<string, string> = {
          [apiFacadeKeyName]: apiFacadeKeyValue,
          [apiOnboardingKeyName]: apiOnboardingKeyValue,
        };

        let additionalHeaders = {};
        if (rawHeaders) {
          if (Array.isArray(rawHeaders)) {
            additionalHeaders = rawHeaders.reduce<Record<string, string>>(
              (acc, curr) => {
                if (API_SERVICE_KEYS[curr]) {
                  acc[curr] = API_SERVICE_KEYS[curr];
                }
                return acc;
              },
              {},
            );
            headers = { ...headers, ...additionalHeaders };
          } else if (typeof rawHeaders === "object") {
            additionalHeaders = rawHeaders;
          }
          headers = { ...headers, ...additionalHeaders };
        }
        try {
          const res = await getDataFetcher().get(path, {
            withCredentials: true,
            headers,
          });
          return { data: res?.data };
        } catch (e) {
          const error = transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
            e as AxiosError,
          );
          return { error };
        }
      },
    }),
  }),
});

export const { useLazyGetSelectListQuery } = selectApi;
